import Image from 'next/image';
import Link from 'next/link';
import { prefix } from '../../lib/auth';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

const LandingFooter = () => {
    const router = useRouter();
    const t = useTranslations('landing');

    return (
        <div className="pt-[66px] lg:pt-[182px] pb-[8px] px-[5px] relative">
            <div className="rounded-[32px] bg-[url('/images/footer-bg.png')] bg-no-repeat bg-cover bg-[#0f0f0f] w-full h-[700px] grid lg:flex lg:flex-col lg:justify-end content-center gap-[150px] lg:gap-[150px]">
                <div className=" mx-auto grid items-center justify-center gap-[35px]">
                    <p className="text-[30px] lg:text-[60px] leading-[45px] lg:leading-[90px] font-medium lg:font-semibold text-[#fdfdfd] leading-[48px] text-center">{t('footerTitle')}
                        <br /> {t('footerTitleLine2')}
                    </p>
                    <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=email`} className="grid items-center justify-center text-[18px] text-[#FDFDFD] m-auto w-[228px] py-[11px] rounded-[14px]"
                        style={{
                            boxShadow: `
                        0px 14px 6px -8px #000000,
                        0px 10px 10px -3.75px #FFFFFF40 inset,
                        0px 0.6px 0.6px -1.25px #FFFFFFB8 inset,
                        0px 2.29px 2.29px -2.5px #FFFFFFA2 inset,
                        0px 2px 1px 0px #FFFFFF80 inset
                    `
                        }}
                    >{t('getStartedForFree')}</Link>
                </div>
                <div className="grid lg:flex justify-between items-center gap-[52px] lg:gap-0 border-t-[1px] m-auto lg:m-0 border-dashed border-[#FFFFFF1F]">
                    <div className="grid gap-[20px] justify-items-center lg:justify-items-start lg:gap-[48px] lg:pl-[110px] lg:pb-[46px] m-auto lg:m-0">
                        <Image src="/images/landing-footer-logo.svg" width={113} height={43} alt="logo" className="h-[43px] mt-[20px]" />
                        <ul className="flex items-center gap-[14px]">
                            <li className="font-semibold text-[13px] leading-[18px] text-[#fdfdfd]"><Link
                                href="index.html">{t('home')}</Link></li>
                            <li className="font-semibold text-[13px] leading-[18px] text-[#fdfdfd]"><Link
                                href="about-us.html">{t('aboutUs')}</Link></li>
                            <li className="font-semibold text-[13px] leading-[18px] text-[#fdfdfd]"><Link
                                href="https://blog.workpeg.com/were-on-a-mission-to-fix-a-big-bs/" target="_blank">{t('blog')}</Link></li>
                        </ul>
                    </div>
                    <div className="grid items-center content-center gap-[12px] lg:pl-[15px] lg:border-l-[1px] border-dashed border-[#FFFFFF1F] lg:pr-[320px] h-full">
                        <p className="font-medium text-[16px] leading-[25.6px] text-[#fdfdfd]">{t('getStartedForFree')}</p>
                        <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=email`} className="w-fit px-[50px] py-[6px] bg-[#FDFDFD] rounded-[6px] text-[#0D0D0E] text-[14px] leading-[24px] hidden lg:block" target="_blank">{t('signUp')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingFooter;